export default "__VITE_ASSET__njLueWa$__"